import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { index, pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { Competency } from '../category'
import { Lesson } from './lesson'

export const LessonToCompetency = pgTable(
  'lesson_to_competency',
  {
    lessonId: uuid()
      .notNull()
      .references(() => Lesson.id, { onDelete: 'cascade' }),
    competencyId: uuid()
      .notNull()
      .references(() => Competency.id, { onDelete: 'cascade' }),
  },
  (table) => [
    primaryKey({ columns: [table.lessonId, table.competencyId] }),
    index('lesson_to_competency_lesson_idx').on(table.lessonId),
    index('lesson_to_competency_competency_idx').on(table.competencyId),
  ],
)

export const lessonToCompetencyRelations = relations(LessonToCompetency, ({ one }) => ({
  lesson: one(Lesson, {
    fields: [LessonToCompetency.lessonId],
    references: [Lesson.id],
  }),
  competency: one(Competency, {
    fields: [LessonToCompetency.competencyId],
    references: [Competency.id],
  }),
}))

export const InsertLessonToCompetencySchema = createInsertSchema(LessonToCompetency)
export const UpdateLessonToCompetencySchema = createUpdateSchema(LessonToCompetency).partial()
export const SelectLessonToCompetencySchema = createSelectSchema(LessonToCompetency)

export type InsertLessonToCompetency = typeof LessonToCompetency.$inferInsert
export type UpdateLessonToCompetency = z.infer<typeof UpdateLessonToCompetencySchema>
export type SelectLessonToCompetency = typeof LessonToCompetency.$inferSelect
